// Bits shared by the admin pages.
import { Pill } from '../../components/ui/index.jsx';

export const ROLE_LABELS = { admin: 'Platform admin', user: 'Customer' };

export const STATUS = {
  active: { label: 'Active', tone: 'good' },
  blocked: { label: 'Blocked', tone: 'bad' },
  unconfirmed: { label: 'Email not confirmed', tone: 'warn' },
};

export function StatusPill({ status }) {
  const s = STATUS[status] || { label: status, tone: 'neutral' };
  return <Pill tone={s.tone}>{s.label}</Pill>;
}

export function RolePills({ roles }) {
  if (!roles?.length) return <span className="muted small">No role</span>;
  return (
    <span className="pill-row">
      {roles.map((r) => <Pill key={r} tone={r === 'admin' ? 'navy' : 'info'}>{ROLE_LABELS[r] || r}</Pill>)}
    </span>
  );
}

export { fmtDate, fmtDateTime } from '../../utils/format.js';
export const fullName = (u) => [u.first_name, u.last_name].filter(Boolean).join(' ') || '—';

const ACTIONS = {
  'user.create': 'Account created',
  'user.update': 'Details changed',
  'user.block': 'Blocked from signing in',
  'user.unblock': 'Unblocked',
  'user.delete': 'Account deleted',
  'role.grant': 'Role added',
  'role.revoke': 'Role removed',
  'password.reset_requested': 'Asked for a password reset code',
  'password.reset_sent': 'Password reset code sent by an admin',
  'password.reset': 'Password changed with a reset code',
};

export function describeActivity(a) {
  let text = ACTIONS[a.action] || a.action;
  const d = a.detail || {};
  if (d.role) text += `: ${ROLE_LABELS[d.role] || d.role}`;
  if (a.action === 'user.block' && d.reason) text += ` (${d.reason})`;
  if (a.action === 'user.update') text += `: ${Object.keys(d).map((k) => k.replace('_', ' ')).join(', ')}`;
  if (a.action === 'password.reset_sent' && d.signed_out) text += ', and signed out everywhere';
  return text;
}

/** Who did it, for the activity list. A deleted account's placeholder address is never shown. */
export function actorLabel(a) {
  if (!a.actor_email) return '';
  return a.actor_email.endsWith('@deleted.summitshield.invalid') ? 'a deleted account' : a.actor_email;
}
